import { ReactNode, createContext } from "react";
import { ToastContainer, toast } from "react-toastify";

interface ToastProviderProps {
    children: ReactNode;
}

interface ToastType {
    successToast: (title: string, message?: string) => void
    errorToast: (title: string, message?: string) => void
    axiosErrorToast: (e: any) => void
}

const toastContent = (title: string, messages?: string[]) => (
    <>
        <div>{title}</div>
        {messages && (
            <ul>
                {messages.map(m => <li><small>{m}</small></li>)}
            </ul>
        )}
    </>
);

export function ToastProvider({ children }: ToastProviderProps) {

    const successToast = (title: string, description?: string) => {
        toast.success(toastContent(title, description ? [description] : undefined));
    }

    const errorToast = (title: string, description?: string) => {
        toast.error(toastContent(title, description ? [description] : undefined));
    }

    const axiosErrorToast = (e: any) => {
        if (e?.response?.data) {
            const title = e.response.data.message || 'Erro ao realizar requisição';
            const messages = e.response.data.errors || [];
            toast.error(toastContent(title, messages));
        } else {
            toast.error(toastContent('Erro ao realizar requisição'));
        }
    }

    return (
        <ToastContext.Provider value={{ successToast, errorToast, axiosErrorToast }}>
            {children}
            <ToastContainer theme="dark"/>
        </ToastContext.Provider>
    )
}

export const ToastContext = createContext<ToastType | undefined>(undefined);